var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("transition", { attrs: { name: "fade", css: _vm.useTransition } }, [
    _vm.isVisible
      ? _c(
          "div",
          {
            ref: "modal",
            staticClass: "modal",
            class: { visible: _vm.isVisible },
          },
          [
            _c("div", {
              staticClass: "modal__overlay",
              on: { click: _vm.close },
            }),
            _c(
              "div",
              { staticClass: "modal__content" },
              [
                _c("icon-button", {
                  ref: "modal-close",
                  staticClass: "modal__close",
                  attrs: { label: "Close Modal", icon: "close" },
                  on: { click: _vm.close },
                }),
                _vm._t("content"),
              ],
              2
            ),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }